import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { BaseCaseSearchResultDto, LinkedCaseDetailsDto } from '../../models/dto';
import { BaseCaseHubService } from '../../services/base-case-hub.service';

@Component({
  selector: 'boi-linked-case-details',
  templateUrl: './linked-case-details.component.html',
  styleUrls: ['./linked-case-details.component.scss']
})
export class LinkedCaseDetailsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public caseId: string;
  @Input() public showDetailsAlways: boolean;
  @Input() public isExpandable = true;

  public relativeRoutePath = '/';
  public showCaseAllocation = true;

  @Input()
  public set interfaceTypeCode(value: string) {
    this.relativeRoutePath = `/${value}`;
    this.showCaseAllocation = false;
  }

  public showLinkedCaseDetails: boolean;
  public linkedCaseDetails: LinkedCaseDetailsDto;

  private linkedCaseDetailsObservable: Observable<LinkedCaseDetailsDto>;
  private destroySubject$ = new Subject();

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;

  constructor(private baseCaseHubService: BaseCaseHubService<BaseCaseSearchResultDto>) {}

  public ngOnInit(): void {
    this.initDetailsDataRetrival(this.caseId);
    if (this.showDetailsAlways) {
      this.loadDetailsData();
      this.showLinkedCaseDetails = true;
    }
  }

  private initDetailsDataRetrival(caseIdHash: string): void {
    this.linkedCaseDetailsObservable = this.baseCaseHubService.getLinkedCaseDetails(caseIdHash);
  }

  public getLinkedCaseDetails(): void {
    if (this.isExpandable) {
      if (!this.linkedCaseDetails) {
        this.loadDetailsData();
      }
      this.showLinkedCaseDetails = !this.showLinkedCaseDetails;
    }
  }

  private loadDetailsData(): void {
    this.linkedCaseDetailsObservable
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((linkedCaseDetailsDto) => (this.linkedCaseDetails = linkedCaseDetailsDto));
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.caseId && changes.caseId.previousValue) {
      this.initDetailsDataRetrival(changes.caseId.currentValue);
      this.loadDetailsData();
    }
  }

  public ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
